import React from 'react';
import { c as classnames } from './index-2586sEvh.js';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { w as withProviders } from './withProviders-l3mjYkR2.js';

const Banner = ({ daysLeft, categoryName, categoryNameEn, productNameEn, currencyCode, ends, categoryId, replacementName, grammar, promoType, }) => {
    const { t: tPromo } = useTranslation('', { keyPrefix: '$common.$promotion' });
    const { route } = useRouter();
    const page = (() => {
        if (route.includes('/p/')) {
            return 'product';
        }
        if (route.includes('/c/')) {
            return 'category';
        }
        return 'homepage';
    })();
    const displayName = replacementName || categoryName;
    const prodNameClass = replacementName ? 'replacementName' : 'currentName';
    const countdownIsActive = daysLeft <= 3;
    const countdownClass = (() => {
        // Below 9 lines is a workaround for when the API returns a value like "0.99930555555556"
        if (daysLeft > 0 && daysLeft < 1) {
            return 'ends-today';
        }
        if (daysLeft > 1 && daysLeft < 2) {
            return 'ends-tomorrow';
        }
        if (daysLeft > 2 && daysLeft < 3) {
            return 'ends-date';
        }
        switch (daysLeft) {
            case 0:
                return 'ends-today';
            case 1:
                return 'ends-tomorrow';
            case 2:
            case 3:
                return 'ends-date';
            default:
                return '';
        }
    })();
    const countdownCopy = (() => {
        // Below 9 lines is a workaround for when the API returns a value like "0.99930555555556"
        if (daysLeft > 0 && daysLeft < 1) {
            return 'endsToday';
        }
        if (daysLeft > 1 && daysLeft < 2) {
            return 'endsTomorrow';
        }
        if (daysLeft > 2 && daysLeft < 3) {
            return 'ends';
        }
        switch (daysLeft) {
            case 0:
                return 'endsToday';
            case 1:
                return 'endsTomorrow';
            case 2:
            case 3:
                return 'ends';
            default:
                return '';
        }
    })();
    const promoTestId = `promo-content${countdownClass ? ` ${countdownClass}` : ''}`;
    return (React.createElement("div", { "data-testid": promoTestId, className: classnames('promo-wrapper', promoType, countdownIsActive ? 'last-call' : 'initial', page, categoryId, categoryNameEn && `cat-${categoryNameEn}`, productNameEn && `prod-${productNameEn}`, currencyCode.toLowerCase()) },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "top-promo" },
                React.createElement("div", { className: "promo-inner" },
                    React.createElement("div", { className: "before-name" },
                        React.createElement("span", { className: "save" }),
                        React.createElement("span", { className: "upto" }),
                        React.createElement("span", { className: "pr-copy1" }),
                        React.createElement("span", { className: "percentage" }),
                        React.createElement("span", { className: "pr-copy2" })),
                    React.createElement("div", { className: "pr-name", id: "banProdName" },
                        React.createElement("span", { className: prodNameClass },
                            grammar && React.createElement("span", null,
                                "\u00A0",
                                grammar),
                            displayName && (React.createElement(React.Fragment, null,
                                "\u00A0",
                                displayName)),
                            React.createElement("span", { className: "asterisk" }, "*"))),
                    React.createElement("div", { className: "after-name" },
                        React.createElement("span", { className: "pr-copy3" })),
                    countdownIsActive && (React.createElement("div", { className: classnames('countdown', countdownClass) },
                        "\u00A0",
                        React.createElement("span", { className: "pr-ends" },
                            countdownCopy && tPromo(countdownCopy, { ends: tPromo(ends) }),
                            "*"),
                        React.createElement("span", { className: "pr-altend" }))))))));
};
var Banner$1 = withProviders(Banner, { translation: true });

export { Banner$1 as B };
//# sourceMappingURL=Banner-hHc_G3rw.js.map
